import Title from './block-title';

export default Title;